import React, { useState, useEffect } from "react";
import { CommonSearchInput } from "../../common";
import { Dropdown } from "../../common/Dropdown";
import { CategoryStatus } from "../../../constants/status";
import { FilterButton } from "../../common/filterButton";

interface SearchFormProps {
  searchForm: {
    search_string: string;
	faq_type: string;
    status: string;
  };
  setSearchForm: React.Dispatch<
    React.SetStateAction<{
      search_string: string;
	  faq_type: string;
      status: string;
    }>
  >;
  handleSearchClick: (form: { search_string: string; faq_type: string; status: string }) => void; // Pass latest form values
}

const SearchForm: React.FC<SearchFormProps> = ({
  searchForm,
  setSearchForm,
  handleSearchClick,
}) => {
  const [searchError, setSearchError] = useState<string>("");
  const [formChanged, setFormChanged] = useState<boolean>(false); //This is used to control unnecssary call when form is not changed
  const [triggerSearch, setTriggerSearch] = useState<boolean>(false); //Trigger effect after reset

  // UseEffect to trigger the search after state updates
  useEffect(() => {
    if (triggerSearch) {
      handleSearchClick(searchForm); //Use the latest form values
      setTriggerSearch(false);
    }
  }, [searchForm, triggerSearch, handleSearchClick]);

  // Handle form input changes
  const handleFormInputChange = (
    event: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>
  ) => {
    const { name, value } = event.target;
    setSearchForm((prev) => ({
      ...prev,
      [name]: value,
    }));
    //on any filter value chnage then set form changed flag to true
    if (!formChanged) setFormChanged(true);
  };

  //Search handler
  const searchData = () => {
    if (!searchForm.search_string && !searchForm.faq_type && !searchForm.status) {
      setSearchError("Please enter at least one filter to search.");
      return;
    }
    //If search form is not changed then return
    if (!formChanged) {
      return;
    }
    setSearchError("");
    setTriggerSearch(true); //Trigger effect after state update
    setFormChanged(false);
  };

  //Reset handler
  const resetSearch = () => {
    setSearchForm({
      search_string: "",
	  faq_type: "",
      status: "",
    });
    setSearchError("");
    setTriggerSearch(true); //Trigger effect after state update
  };

  return (
    <div className="row g-2 mb-3">
      <div className="col-md-2">
        <CommonSearchInput
          type="text"
          name="search_string"
          placeholder="Enter keyword to search"
          value={searchForm.search_string}
          onChange={handleFormInputChange}
          className="form-control-sm"
        />
      </div>
	  <div className="col-md-2">
		<select
		  className="form-select form-select-sm mb-2"
		  name="faq_type"
		  value={Number(searchForm.faq_type)}
		  onChange={handleFormInputChange}
		>
			<option value="">Faq Type</option>
			<option key={1} value={1}>General</option>
			<option key={2} value={2}>Product</option>
			<option key={3} value={3}>Epuja</option>
			<option key={4} value={4}>Kundli</option>
			<option key={5} value={5}>Blog</option>
			<option key={6} value={6}>Yoga & Wellness</option>
		</select>
	  </div>
      <Dropdown
        name="status"
        value={searchForm.status}
        onChange={handleFormInputChange}
        options={CategoryStatus}
      />
      <FilterButton handleFilter={searchData} handleReset={resetSearch} />
      {searchError && (
        <div className="text-danger small" style={{ display: "block" }}>
          <div>{searchError}</div>
        </div>
      )}
    </div>
  );
};

export default SearchForm;
